// extracted by mini-css-extract-plugin
export default {"link":"DocumentMorePopover_link__5xdpK","button":"DocumentMorePopover_button__yG22V"};